import React from 'react';
import dayjs from 'dayjs';

import './print.css';
import requireAuth from '~components/hocs/requireAuth';
import { PrintableExportShell } from '~components/PrintableLayout';
import { DiscoverabilityView } from '~features/ai-insights/discoverability';

function AIInsightsDiscoverabilityExport() {
  React.useEffect(() => {
    document.title = `Prerender - AI Insights Discoverability export PDF ${dayjs().format('YYYY-MM-DD')}`;
  }, []);

  return (
    <PrintableExportShell>
      <DiscoverabilityView print />
    </PrintableExportShell>
  );
}

export default requireAuth(AIInsightsDiscoverabilityExport);
